import ColorCard from './ColorCard';

const Palette = ({ title, palette }) => (
  <div className="Palette">
    <h3>{title}</h3>
    <div className="Palette-cards">
      {Object.entries(palette).map(([colorName, colorValue], index) => (
        <ColorCard key={index} colorName={colorName} colorValue={colorValue} />
      ))}
    </div>
  </div>
);

export default Palette;
